const IdentityProvidersConstants = {
  GET_SUCCESS: 'IDPROV_GET_SUCCESS',
  GET_FAILURE: 'IDPROV_GET_FAILURE',
  SET_VALUE: 'IDPROV_SET_VALUE',
  SET_PASSWORDDIRTY: 'IDPROV_SET_PASSWORDDIRTY',
  SAVE: 'IDPROV_SAVE',
  SAVE_SUCCESS: 'IDPROV_SAVE_SUCCESS',
  SAVE_FAILURE: 'IDPROV_SAVE_FAILURE',
  REVERT: 'IDPROV_REVERT'
};

export default IdentityProvidersConstants;